var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "align": "stretch",
      "justify": "space-between"
    }
  }, [_c('v-img', {
    staticClass: "ml-5",
    attrs: {
      "src": require('../../assets/st-pro-logo.svg'),
      "max-width": "170px",
      "contain": ""
    }
  }), _vm.currentPlan ? _c('v-row', {
    staticClass: "justify-end align-center ma-0"
  }, [_c('nav', [_c('ul', {
    staticClass: "nav-list font-weight-medium"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active': this.active == 'PRODUCTS'
    },
    on: {
      "click": function ($event) {
        return _vm.sendNavigationEvent('products');
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('navigation_products')) + " ")])], 1), _vm.totalCodesCount ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': this.active == 'GALLERY'
    },
    on: {
      "click": function ($event) {
        return _vm.sendNavigationEvent('gallery');
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/gallery"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('navigation_gallery')) + " ")])], 1) : _vm._e(), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': this.active == 'DASHBOARD'
    },
    on: {
      "click": function ($event) {
        return _vm.sendNavigationEvent('dashboard');
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('navigation_dashboard')) + " ")])], 1), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': this.active == 'UPGRADE'
    },
    on: {
      "click": function ($event) {
        return _vm.sendNavigationEvent('upgrade');
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/upgrade?source=menu"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('navigation_plans')) + " ")])], 1)])]), _c('profile-navigation-btn')], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }